import React, { useState, useEffect } from "react";
import User from "../global/User";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PlaceOrders() {
  const [cartDetail, setCartDetail] = useState(null);
  const [currentBalance, setCurrentBalance] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [orderSerial, setOrderSerial] = useState(null);

  const fetchCartDetail = async () => {
    let user = User.getUser();
    if (!user) window.location.href = "/";
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODE_API_URL}/shopperrds/checkout`,
        {
          key: process.env.REACT_APP_MOBILE_API_KEY,
          token: process.env.REACT_APP_MOBILE_API_TOKEN,
          merchantId: user.id,
          source: "web",
        }
      );
      if (response.data.Response.status === 200) {
        setCartDetail(response.data.Response.data);
      } else {
        toast.error(response.data.Response.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (err) {
      console.error("Error fetching cart detail", err);
    }
  };
  useEffect(() => {
    fetchCartDetail();
  }, []);

  const getMerchantBalance = async () => {
    let user = User.getUser();
    let data = {
      _id: user.id,
    };
    try {
      // const response = await axios.post("/shopperrds/getMerchant", data);
      const response = await axios.post(
        `${process.env.REACT_APP_NODE_API_URL}/shopperrds/getMerchant`,
        data
      );
      if (response.data.error === 0) {
        setCurrentBalance(response.data.response.balance);
      } else {
        console.log("Error", response);
      }
    } catch (err) {
      console.error("API call failed:", err);
    }
  };
  useEffect(() => {
    getMerchantBalance();
  }, []);


  const fetchOrderId = async () => {
    let user = User.getUser();
    if (!user) window.location.href = "/";
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODE_API_URL}/shopperrds/orderid`,
        {
          key: process.env.REACT_APP_MOBILE_API_KEY,
          token: process.env.REACT_APP_MOBILE_API_TOKEN,
          merchantId: user.id,
          source: "web",
        }
      );
      if (response.status === 200) {
        setOrderId(response.data.data.legacyOrderid);
        setOrderSerial(response.data.data.orderSerial);
      } else {
        toast.error(response.data.Response.msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      // console.log(response.data.data.legacyOrderid);
      //console.log(response.data.data.orderSerial)
    } catch (err) {
      console.error("Error fetching cart detail", err);
    }
  };
  useEffect(() => {
    fetchOrderId();
  }, []);

  const handlePayNow = async () => {
    let user = User.getUser();
    if (!user) {
      window.location.href = "/";
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODE_API_URL}/shopperrds/deductBalance`,
        {
          key: process.env.REACT_APP_MOBILE_API_KEY,
          token: process.env.REACT_APP_MOBILE_API_TOKEN,
          merchantId: user.id,
          amount: Math.round(cartDetail.customer.price),
          orderSerial: orderSerial,
          source: "web",
        }
      );
      // console.log(response);
      const cartUpdate = await axios.post(
        `${process.env.REACT_APP_NODE_API_URL}/shopperrds/cartUpdate`,
        {
          key: process.env.REACT_APP_MOBILE_API_KEY,
          token: process.env.REACT_APP_MOBILE_API_TOKEN,
          merchantId: user.id,
          source: "web",
        }
      );
      //  console.log(cartUpdate);
      window.location.href = "/orderSuccess";
    } catch (err) {
      console.error("Error during payment process:", err);
      toast.error("An error occurred. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div>
      {/* payment information */}
      <div
        className=" card border-width-2 border-radius-3 border-color-grey "
        style={{
          width: "95%",
          height: 350,
          marginTop: "20px",
          marginLeft: "30px",
          padding: "1rem",
        }}
      >
        <h1 className="p-2 text-8 "> Payment Information </h1>
        <div>
          <table className="table table-hover">
            <tbody>
              <tr>
                <td
                  className=" text-right text-5  "
                  style={{ height: "50px" }}
                >
                  Shopperr Order Id:
                </td>
                <td className=" text-center text-5 " style={{ height: "50px" }}>
                  {orderSerial}
                </td>
              </tr>
              {/* row 2 */}
              <tr>
                <td className="text-right text-5 " style={{ height: "50px" }}>
                  Price:
                </td>
                <td className=" text-center text-5 " style={{ height: "50px" }}>
                  ₹ {cartDetail ? Math.round(cartDetail.customer.price) : ""}
                </td>
              </tr>
              {/* row3 */}
              <tr>
                <td className="text-right text-5  " style={{ height: "50px" }}>
                  Total:
                </td>
                <td className=" text-center text-5 " style={{ height: "50px" }}>
                  ₹ {cartDetail ? Math.round(cartDetail.customer.price) : ""}
                </td>
              </tr>
              {/* row4 */}
              <tr>
                <td className="text-right text-5 " style={{ height: "50px" }}>
                  Status:
                </td>
                <td
                  className=" text-center text-5 "
                  style={{ height: "50px" }}
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br />
      {/* Ewallet block */}
      <div
        className=" card border-width-2 border-radius-3 border-color-grey "
        style={{
          width: "95%",
          height: 50,
          marginTop: "20px",
          marginLeft: "30px",
        }}
      >
        <p
          className=" font-weight-semibold pt-2 pl-4 text-color-grey text-5 text-color-hover-dark "
          style={{ cursor: "pointer" }}
        >
          E-wallet
        </p>
      </div>
      <br />

      {/* current balance block */}
      <div
        className=" card border-width-2 border-radius-3 border-color-grey "
        style={{
          width: "95%",
          height: 180,
          marginTop: "20px",
          marginLeft: "30px",
        }}
      >
        <h5 className="p-3 pt-4 text-3 ">
          Current Balance: ₹ {currentBalance ? currentBalance : ""}
        </h5>

        <div className="text-4 pl-3 " style={{ color: "rgb(246,115,6)" }}>
          By placing this order,you agree to the
          <a target="blank" href="/pages/terms-conditions">
            {" "}
            Term Of Use{" "}
          </a>
          and
          <a target="" href="/pages/terms-conditions">
            {" "}
            Privacy Policy{" "}
          </a>
          of Shopperr.in
        </div>

        <div>
          {(currentBalance ? currentBalance : "") >
            parseInt(cartDetail ? cartDetail.customer.price : "") && (
            <button
              onClick={handlePayNow}
              type="submit"
              className="btn btn-dark btn-modern btn-block text-uppercase bg-color-hover-primary border-color-hover-primary border-radius-1 text-3  "
              style={{
                width: "15%",
                height: "70%",
                marginTop: "15px",
                marginLeft: "1rem",
              }}
            >
              Pay Now <i className="fas fa-arrow-right ml-2" />
            </button>
          )}
          {(currentBalance ? currentBalance : "") <
            parseInt(cartDetail ? cartDetail.customer.price : "") && (
            <button
              type="submit"
              className="btn btn-dark btn-modern btn-block text-uppercase bg-color-hover-primary border-color-hover-primary border-radius-1 text-3  "
              style={{
                width: "15%",
                height: "70%",
                marginTop: "15px",
                marginLeft: "1rem",
              }}
            >
              Recharge Now <i className="fas fa-arrow-right ml-2" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
export default PlaceOrders;
